import React from 'react';

function Service(){
    return (
        <>
            <div className='divresult' style={{backgroundColor: '#8080800a'}}>
                <h1>Search any Food Recipie</h1>
            </div>
        </>
    )
}

export default Service;